const normalizeCandidateValues = (rawValue) => {
  if (rawValue === undefined || rawValue === null) {
    return [];
  }

  if (Array.isArray(rawValue)) {
    return rawValue;
  }

  return [rawValue];
};

export const normalizeContractTypes = (contractTypes, contractType) => {
  const rawValues =
    contractTypes !== undefined && contractTypes !== null
      ? normalizeCandidateValues(contractTypes)
      : normalizeCandidateValues(contractType);

  const normalizedValues = [];
  const seen = new Set();

  rawValues.forEach((rawValue) => {
    const value = String(rawValue ?? "").trim();
    if (!value || seen.has(value)) {
      return;
    }

    normalizedValues.push(value);
    seen.add(value);
  });

  return normalizedValues;
};

export const getOfferContractTypes = (offer = {}) =>
  normalizeContractTypes(
    offer?.contract_types ?? offer?.contractTypes,
    offer?.contract_type ?? offer?.contractType,
  );

export const getPrimaryContractType = (offer = {}) => {
  const contractTypes = getOfferContractTypes(offer);
  return contractTypes[0] || "";
};

export const getContractTypesLabel = (offer = {}, separator = " • ") =>
  getOfferContractTypes(offer).join(separator);
